import React from "react";
import { Routes, Route } from "react-router-dom";

import Dashboard from "./Dashboard";

const index = () => {
	return (
		<Routes>
			<Route index element={<Dashboard />} />
		</Routes>
	);
};

export default index;
